import { SportDefinition, SportProfileField } from '../sport.types';
import { BASEBALL_POSITIONS } from './baseball.enums';
import { BaseballScoringAdapter } from './baseball-scoring.adapter';
import { BaseballLiveScorerComponent } from './components/baseball-live-scorer.component';
import { BaseballScoringSetupComponent } from './components/baseball-scoring-setup.component';
import { BaseballSpectatorComponent } from './components/baseball-spectator.component';

const profileFields: SportProfileField[] = [
  {
    key: 'primaryPosition',
    label: 'Primary position',
    section: 'profile',
    type: 'select',
    filterable: true,
    options: BASEBALL_POSITIONS.map(p => ({ value: p.value, label: p.label }))
  },
  { key: 'jerseyNumber', label: 'Jersey #', section: 'profile', type: 'number', min: 0, max: 99 },
  {
    key: 'battingSide',
    label: 'Bats',
    section: 'profile',
    type: 'select',
    options: [
      { value: 1, label: 'Right' },
      { value: 2, label: 'Left' },
      { value: 3, label: 'Switch' }
    ]
  },
  {
    key: 'throwingHand',
    label: 'Throws',
    section: 'profile',
    type: 'select',
    options: [
      { value: 1, label: 'Right' },
      { value: 2, label: 'Left' }
    ]
  },
  { key: 'pitching.maxPitches', label: 'Max pitches', section: 'profile', type: 'number', min: 0, max: 200 }
];

export function createBaseballSportDefinition(input: { scoring: BaseballScoringAdapter }): SportDefinition {
  return {
    key: 'baseball',
    label: 'Baseball',
    icon: 'sports_baseball',
    colorToken: '--brijjsports-red',
    athletesNoun: 'Players',
    terminology: {
      eventNoun: 'Tournament',
      eventNounPlural: 'Tournaments',
      sessionNoun: 'Game',
      opponentNoun: 'Opponent',
      scoreUnitNoun: 'Run',
      resultPlacementHelp: '1st, Runner-up, 3-1'
    },
    rulesSummary: 'Nine-inning games scored by runs; lineups, pitch counts, and PitchSmart rest rules are tracked per pitcher.',
    scoring: input.scoring,
    profileFields,
    setupComponent: BaseballScoringSetupComponent,
    liveComponent: BaseballLiveScorerComponent,
    spectatorComponent: BaseballSpectatorComponent,
    nav: {
      owner: [
        { route: '/owner/athletes', label: 'Players', icon: 'users' },
        { route: '/owner/programs', label: 'Programs', icon: 'layers' },
        { route: '/owner/teams', label: 'Teams', icon: 'users' }
      ],
      coach: [
        { route: '/coach/roster', label: 'Players', icon: 'users' },
        { route: '/coach/scoring', label: 'Box scores', icon: 'bar-chart' }
      ],
      athlete: [{ route: '/athlete/scores', label: 'Box scores', icon: 'bar-chart' }]
    }
  };
}
